import React, { useEffect, useRef, useState } from "react";
import "./racing.css";
import { socket } from "../../io";
import logo from "../../assets/logo.png";

const Racing = (props) => {
  const bonusValue = Number(props.factor?.value ?? props.factor ?? 1);
  const hasBonus = bonusValue > 1;
  const [showBonus, setShowBonus] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [videoSrc, setVideoSrc] = useState("");
  const [videoReady, setVideoReady] = useState(false);
  const videoRef = useRef(null);
  const currentVideoRef = useRef("");

  const loadVideo = (videoName) => {
    if (!videoName) return;
    const nextVideo = `/videos/${videoName}`;
    if (currentVideoRef.current === nextVideo) return;
    currentVideoRef.current = nextVideo;
    setVideoReady(false);
    setShowMessage(nextVideo.includes("x"));
    setVideoSrc(nextVideo);
  };

  useEffect(() => {
    if (!hasBonus) {
      setShowBonus(false);
      return undefined;
    }
    const interval = window.setInterval(() => setShowBonus(value => !value), 1800);
    return () => window.clearInterval(interval);
  }, [hasBonus]);

  useEffect(() => {
    const handleVideo = (data) => {
      loadVideo(data?.video);
    };
    socket.on("video", handleVideo);
    // The race screen mounts after the server's screen event. Ask for a replay
    // so the one-time video event cannot be missed during that transition.
    socket.emit("request-video");
    return () => socket.off("video", handleVideo);
  }, []);

  useEffect(() => {
    loadVideo(props.video);
  }, [props.video]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video || !videoSrc || videoSrc.includes("x")) return;
    video.currentTime = 0;
    const playPromise = video.play();
    if (playPromise) playPromise.catch(() => setShowMessage(true));
  }, [videoSrc]);

  const handleEnded = () => {
    const video = videoRef.current;
    if (video && Number.isFinite(video.duration)) video.currentTime = Math.max(video.duration - 0.05, 0);
  };

  return (
    <div className={`racing-native-player ${showMessage ? "racing-native-player--notice" : ""}`}>
      {!showMessage && videoSrc && <video ref={videoRef} className={`racing-native-video ${videoReady ? "racing-native-video--ready" : ""}`} src={videoSrc} autoPlay muted playsInline preload="auto" onCanPlay={() => setVideoReady(true)} onPlaying={() => setVideoReady(true)} onEnded={handleEnded} onError={() => { setVideoReady(false); setShowMessage(true); }} />}
      {!showBonus && <img className="racing-native-logo" src={logo} alt="" />}
      {hasBonus && showBonus && <div className={`racing-bonus ${bonusValue === 2 || bonusValue === 3 ? "racing-bonus--hot" : ""}`}><small>BONO</small>X{bonusValue}</div>}
      {showMessage && <div className="racing-transmission-error"><strong>NOTICE / AVISO</strong><span>Error in transmission, the race is active...</span><span>Error en transmisión, la carrera está activa...</span></div>}
    </div>
  );
};

export default Racing;
